import { default as logo } from '../assets/images/saas1.svg';
import authLanguages from './authLanguages';

const getAuth0Options = (redirectUrl, language) => ({
  container: 'auth0_login',
  allowedConnections: [process.env.REACT_APP_AUTH0_CONNECTION],
  auth: {
    redirectUrl: process.env.REACT_APP_AUTH0_REDIRECT_URL,
    responseType: 'token',
    params: {
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: 'openid profile email',
      appState: redirectUrl,
    }
  },
  theme: {
    logo,
    primaryColor: '#e91e63'
  },
  rememberLastLogin: false,
  allowShowPassword: true,
  avatar: null,
  languageDictionary: authLanguages[language]
});

export default getAuth0Options;
